module.exports = __webpack_public_path__ + "dingbeauty-landing/img/img_reservation.a6ad0453.png";